import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusPermission } from '../../enum';
import { sortQueuesByLob, useQueueAPI, useQueuesAPI, useSelectedQueue, useWorkTypeAPI } from './queue/selectors';
import { useEffectiveCapacityPermission, usePlanAPI, useWizardParams } from './selectors';
export var WizardLoader = function () {
  var capacityPermission = useEffectiveCapacityPermission();
  var _a = usePlanAPI(),
    planData = _a[0],
    fetchPlanData = _a[1],
    clearPlanData = _a[2];
  var _b = useWorkTypeAPI(),
    clearWorkType = _b[2];
  var _c = useQueuesAPI(),
    queuesData = _c[0],
    fetchQueues = _c[1],
    clearQueuesData = _c[2];
  var _d = useQueueAPI(),
    fetchQueue = _d[1],
    clearQueueData = _d[2];
  var navigate = useNavigate();
  var _e = useWizardParams(),
    id = _e.id,
    step = _e.step;
  var queue = useSelectedQueue();
  var sortedQueues = useMemo(function () {
    var _a;
    return sortQueuesByLob((_a = queuesData.data) !== null && _a !== void 0 ? _a : []);
  }, [queuesData.data]);
  useEffect(function () {
    fetchPlanData();
    return function () {
      clearPlanData();
      clearWorkType();
    };
  }, [clearPlanData, clearWorkType, fetchPlanData]);
  useEffect(function () {
    fetchQueues();
    return clearQueuesData;
  }, [clearQueuesData, fetchQueues]);
  useEffect(function () {
    fetchQueue();
    return clearQueueData;
  }, [clearQueueData, fetchQueue]);
  useEffect(function () {
    if (planData.data && !id) {
      navigate({
        pathname: "/wizard/".concat(planData.data.basePlanId, "/").concat(planData.data.id),
        search: window.location.search
      }, {
        replace: true
      });
    }
  }, [id, navigate, planData.data]);
  useEffect(function () {
    var _a, _b;
    if (sortedQueues.length && !queue) {
      navigate({
        pathname: window.location.pathname,
        search: "queueId=".concat(sortedQueues[0].id, "&step=").concat(step)
      }, {
        replace: true
      });
    }
    if (capacityPermission === StatusPermission.View) {
      var targetQueueId = (_a = queue === null || queue === void 0 ? void 0 : queue.id) !== null && _a !== void 0 ? _a : (_b = sortedQueues[0]) === null || _b === void 0 ? void 0 : _b.id;
      navigate({
        pathname: window.location.pathname,
        search: "queueId=".concat(targetQueueId, "&step=8")
      }, {
        replace: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capacityPermission, queue, sortedQueues]);
  return null;
};